export enum BFXDialogIntent {
  NORMAL,
  INFO,
  NEUTRAL,
  WARNING,
  NEGATIVE,
  POSITIVE,
}
